<template>
  <div class="map-wrapper">
    <GmapMap
      :center="center"
      :zoom="zoom"
      @zoom_changed="update('zoom', $event)"
      @center_changed="update('reportedCenter', $event)"
      @bounds_changed="update('bounds', $event)"
      >
      <GmapCluster
        :gridSize="50"
        >
        <GmapMarker
          v-for="item in items"
          :key="item.id"
          :position="item.position"
        />
      </GmapCluster>
    </GmapMap>
  </div>

</template>

<script>
export default {
  data: () => ({
    reportedCenter: {},
    mapBounds: {},
  }),
  computed: {
    center: {
      get () {
        return this.$store.getters['ui/mapCenter']
      },
      set (position) {
        this.$store.dispatch('ui/updateMapCenter', position)
      },
    },
    zoom: {
      get () {
        return this.$store.getters['ui/mapZoom']
      },
      set (zoom) {
        this.$store.dispatch('ui/updateMapZoom', zoom)
      },
    },
    items () {
      return this.selection.length > 0 ? this.selection : this.unfiltered
    },
  },
  props: {
    unfiltered: Array,
    selection: Array,
  },
  mounted () {
    this.geolocate()
  },
  methods: {
    // receives a place object via the autocomplete component
    geolocate () {
      navigator.geolocation.getCurrentPosition(position => {
        this.center = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        }
      })
    },
    update (field, event) {
      if (field === 'reportedCenter') {
        this.reportedCenter = {
          lat: event.lat(),
          lng: event.lng(),
        }
      } else if (field === 'bounds') {
        this.mapBounds = event
      } else {
        this.$set(this, field, event)
      }
    },
  },
}
</script>

<style>
  .map-wrapper,
  .vue-map-container {
    position: relative;
    height: 100%;
    width: 100%;
  }
</style>
